<template>
  <transition name="fade-splash">
    <div
      class="splash-modal"
      v-show="showModal"
      role="dialog"
      aria-modal="true"
      @keydown.esc="close"
      v-cloak
    >
      <div class="splash-modal__wrapper">
        <button
          type="button"
          class="splash-modal__close"
          :class="closeButtonClass"
          @click="close"
          aria-label="Close splash"
          ref="closeBtn"
        >
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="splash-modal__content" :class="modalClass">
          <slot name="header"></slot>

          <slot></slot>

          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "SplashModal",
  props: {
    splashId: {
      type: String,
      required: true,
    },
    ttlHours: {
      type: Number,
      default: 12,
    },
    modalClass: {
      type: String,
      default: "has-background-white",
    },
    closeButtonClass: {
      type: String,
      default: "has-background-dark-blue",
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    cookieName() {
      return `acc-splash-${this.splashId}`;
    },
  },
  methods: {
    close() {
      this.showModal = false;
      document.body.classList.remove("is-modal-open");
      document.documentElement.style.overflow = "";

      const expiration = new Date();
      expiration.setHours(expiration.getHours() + this.ttlHours);

      this.$setCookie(this.cookieName, "", expiration);

      setTimeout(() => {
        this.$destroy();
        this.$el.remove();
      }, 250);
    },
  },
  mounted() {
    if (this.$getCookie(this.cookieName) !== null) {
      this.close();
    } else {
      this.showModal = true;
      document.body.classList.add("is-modal-open");
      document.documentElement.style.overflow = "hidden";
      this.$nextTick(() => {
        if (this.$refs.closeBtn) {
          this.$refs.closeBtn.focus();
        }
        window.dispatchEvent(new Event("resize"));
      });
    }
  },
};
</script>
